import { getInitialContext } from "@ionic/portals";

/** Routes that always render in dark mode, regardless of the device's system theme -
 *  matched against the initial route reported by native so the root theme provider can
 *  resolve dark from the very first render, before the route's own code-split chunk
 *  (and whatever theme override it applies) has even loaded. */
const ALWAYS_DARK_ROUTES = ["/ready-to-ride"];

/**
 * Reads the initial route synchronously (no React, no async work) so the app's root
 * theme provider can be told up front when a route always renders in dark mode. Without
 * this, the root shell mounts using the device's system theme preference and only
 * later - once the route's own code-split chunk loads - gets overridden by that route's
 * own theme, producing a visible flash of the wrong theme in between.
 */
export function getInitialRouteTheme(): "dark" | undefined {
  try {
    const initialContext = getInitialContext<{ serializedConfigProps: string }>();
    const serializedConfigProps = initialContext?.value?.serializedConfigProps;
    const configProps = serializedConfigProps ? JSON.parse(serializedConfigProps) : {};
    const route: string | undefined =
      configProps.route ?? new URLSearchParams(window.location.search).get("route") ?? undefined;
    if (route && ALWAYS_DARK_ROUTES.some((darkRoute) => route.startsWith(darkRoute))) {
      return "dark";
    }
  } catch {
    // Not running inside a Portal (e.g. an iframe) - fall through to no override.
  }
  return undefined;
}
